<template>
  <div>
    <b-row>
      <b-col class="mt-2"
        ><h3>{{ fragetext }}</h3></b-col
      >
    </b-row>
    <b-row v-if="hinweistext">
      <b-col class="mb-2">{{ hinweistext }}</b-col>
    </b-row>
    <b-row>
      <b-col
        v-for="(opt, index) in optionen"
        :key="index"
        :xs="xs"
        :sm="sm"
        :md="md"
        :lg="lg"
        :xl="xl"
      >
        <b-form-radio
          v-model="selected"
          button
          button-variant="outline-dark"
          :name="`Frage_${Frage}`"
          :value="opt.value ? opt.value : opt.text"
          class="mx-1 my-1"
          >{{ opt.text }}</b-form-radio
        >
      </b-col>
    </b-row>
    <div v-if="showDiv">
      <b-row>
        <b-col>Womit?</b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="(opt, index) in optionen_2"
          :key="`${key}RV${index}`"
          :xs="xs"
          :sm="sm"
          :md="md"
          :lg="lg"
          :xl="xl"
        >
          <b-form-checkbox
            v-model="opt.checked"
            v-bind:checked="opt.checked"
            button
            button-variant="outline-dark"
            :name="`Frage_${Frage}`"
            class="mx-1 my-1"
            @change="handleChange(index)"
            :key="key"
            >{{ opt.text }}</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row>
          <b-col>...oder eine andere Hautkrankheit?</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea
            v-model="antwort_3"
            placeholder=""
            rows="2"
            max-rows="4"
            @change="handleChange"
          ></b-form-textarea>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fragetext: "Leidest Du unter Hautkrankheiten?",
      hinweistext: undefined,
      optionen: [
        { text: "Nein", show_2: false },
        { text: "Ja", show_2: true },
      ],
      optionen_2: [
        { text: "Neurodermitis", checked: false },
        { text: "Schuppenflechte", checked: false },
        { text: "Rosazea", checked: false },
      ],
      selected: undefined,
      showDiv: false,
      antwort_3: "",
      xs: 12,
      sm: 6,
      md: 6,
      lg: 6,
      xl: 6,
      key: Math.random(),
    };
  },
  props: {
    Frage: { required: true },
  },
  watch: {
    selected() {
      this.handleChange();
    },
  },
  methods: {
    handleChange() {
      const curSel = this.optionen.filter((v) => v.text === this.selected);
      if (curSel.length > 0) {
        this.showDiv = curSel[0].show_2;
        if (!this.showDiv) {
            this.optionen_2.forEach(v => {v.checked = false})
            this.antwort_3 = ""
        }
      }

      const selected = [];
      this.optionen_2.forEach((v) => {
        if (v.checked) {
          selected.push(v.value ? v.value : v.text);
        }
      });
      this.$store.commit("setAnwser", {
        Frage: this.Frage,
        Fragentext: this.fragetext,
        Antwort: this.selected,
        Antwort_2: selected,
        Antwort_3: this.antwort_3
      });
    },
  },
  beforeMount() {
    const answ = this.$store.getters.getAnwsers;
    if (answ[this.Frage - 1]) {
      this.selected = answ[this.Frage - 1].Antwort;
      this.optionen_2.forEach((v) => {
        if (answ[this.Frage - 1].Antwort_2.indexOf(v.text) >= 0) {
          v.checked = true;
        }
      });
      this.antwort_3 = answ[this.Frage - 1].Antwort_3;
    }
    this.key = Math.random();
  },
};
</script>